// extracted by mini-css-extract-plugin
module.exports = {"postsPagination":"BlogPostsListing_postsPagination__HlCqx","paginationActive":"BlogPostsListing_paginationActive__8wima"};